<template>
  <div class="Mode me-3">
    <div class="mode_btn dark" @click="changeMode()">
      <div class="btn__indicator dark">
        <div class="btn__icon-container">
          <i class="btn__icon fa-solid"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    changeMode() {
      const body = document.querySelector("body");
      const icon = document.querySelector(".btn__icon");
      const btn = document.querySelector(".Mode .mode_btn");
      const indicator = document.querySelector(".Mode .btn__indicator");

      body.classList.toggle("light");
      icon.classList.add("animated");

      //save true or false
      localStorage.setItem("darkmode", !body.classList.contains("light"));

      console.log(localStorage.getItem("darkmode"));

      if (!body.classList.contains("light")) {
        icon.classList.remove("fa-sun");
        icon.classList.add("fa-moon");
        btn.classList.toggle("dark");
        indicator.classList.toggle("dark");
      } else {
        icon.classList.remove("fa-moon");
        icon.classList.add("fa-sun");
        btn.classList.toggle("dark");
        indicator.classList.toggle("dark");
      }

      setTimeout(() => {
        icon.classList.remove("animated");
      }, 500);
    },
  },
  mounted() {
    const icon = document.querySelector(".btn__icon");
    const darkmode = localStorage.getItem("darkmode");
    const body = document.querySelector("body");
    const btn = document.querySelector(".Mode .mode_btn");
    const indicator = document.querySelector(".Mode .btn__indicator");

    if (!darkmode) {
      localStorage.setItem("darkmode", true);
      icon.classList.add("fa-moon");
    } else if (darkmode == "true") {
      body.classList.add("darkmode");
      icon.classList.add("fa-moon");
      btn.classList.add("dark");
      indicator.classList.add("dark");
    } else if (darkmode == "false") {
      body.classList.add("light");
      icon.classList.add("fa-sun");
      btn.classList.remove("dark");
      indicator.classList.remove("dark");
    }
  },
};
</script>

<style scoped lang="scss">
.btn__icon {
  color: var(--light-icon-color);
}
.mode_btn {
  background-color: var(--bg-black-50);
  width: 2.2em;
  height: 1.2em;
  border-radius: 10em;
  padding: 0 0.5em;
  box-shadow: inset 0 20px 60px rgba(0, 0, 0, 0.008),
    inset 0 20px 20px rgba(0, 0, 0, 0.032),
    inset 0 -4px 4px rgba(0, 0, 0, 0.094);
  position: relative;
  display: flex;

  align-items: center;
  &.dark {
    .btn__indicator {
      background-color: var(--dark-color);
      box-shadow: -2px -1px 3px 1px #4579f42d;
    }
  }

  cursor: pointer;
  .btn__indicator {
    background-color: #fff;
    width: 1em;
    height: 1em;
    border-radius: 50%;
    position: absolute;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
    transition: transform 0.3s ease;
    transform: translateX(-0.2em);
    &.dark {
      transform: translateX(0.4em);
    }
    .btn__icon-container {
      width: 100%;
      height: 100%;

      display: flex;
      justify-content: center;
      align-items: center;
      .btn__icon {
        color: var(--light-icon-color);
        font-size: 1.4rem;
        &.animated {
          animation: spin 0.5s;
        }
      }
    }
  }
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* -------------- DARKMODE -------------- */
</style>
